import { createSlice } from '@reduxjs/toolkit';
import authService from './../../services/auth';

const initialState = {
  loading: false,
  error: false,
  errorLogout: false,
  success: false,
  successLogout: false,
  data: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    startLoading: state => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    hasErrorLogout: (state, action) => {
      state.errorLogout = action.payload;
      state.loading = false;
    },
    loginSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.success = true;
    },
    logoutSuccess: (state) => {
      state.successLogout = true;
      state.loading = false;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => 
          state[item] = initialState[item]
        );
      }
    },
    resetAllData: () => {
      return initialState;
    }
  }
});

export const { startLoading, hasError, hasErrorLogout, loginSuccess, logoutSuccess, resetAllData } = authSlice.actions;

export const login = (data) => async dispatch => {
  dispatch(startLoading());
  try {
    await authService
      .login(data)
      .then(response => dispatch(loginSuccess(response)));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export const loginGoogle = (data) => async (dispatch) => {
  dispatch(startLoading());
  try {
    await authService
      .loginGoogle(data)
      .then((response) => dispatch(loginSuccess(response)));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export const logout = (data) => async dispatch => {
  dispatch(startLoading());
  try {
    await authService
      .logout(data)
      .then(() => dispatch(logoutSuccess()));
  } catch (error) {
    dispatch(hasErrorLogout(error));
  }
};


const authReducer = authSlice.reducer;
export default authReducer;